import { componentsOptions, getModalTabs } from "@/utils/dashboardUtils";
import { isEditorEmpty } from "@/utils/globalUtils";
import { Button, Form, Tabs } from "antd";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import DashboardPreview from "./DashboardPreview";
import AppearanceTab from "./tabs/AppearanceTab";
import AxisTab from "./tabs/AxisTab";
import BasicTab from "./tabs/BasicTab";
import CounterTab from "./tabs/MetricTab";
import DataTab from "./tabs/DataTab";
import EditorTab from "./tabs/EditorTab";
import GaugeTab from "./tabs/GaugeTab";
import TimeFrameTab from "./tabs/TimeFrameTab";

const tabItemsInit = [
  {
    key: "1",
    label: "Basic",
    children: "Content of Tab Pane 1",
  },
];

const onFinishFailed = () => {
  // console.log("error", values);
};

const TAB_COMPONENT_MAP = {
  basic: BasicTab,
  data: DataTab,
  appearance: AppearanceTab,
  axis: AxisTab,
  timeFrame: TimeFrameTab,
  gauge: GaugeTab,
  counter: CounterTab,
  editor: EditorTab,
};

function DashboardAddItemModal({
  show,
  setShow,
  mode = "edit",
  editItem,
  setEditItem,
  gridData,
  setGridData,
  data,
  setData,
  iframe,
  setIframe,
  setComponentModal,
  type = "dashboard",
}) {
  const [form] = Form.useForm();

  // state
  const [selectedComponent, setSelectedComponent] = useState({});
  const [tabItems, setTabItems] = useState(tabItemsInit);
  const [selectedTab, setSelectedTab] = useState("basic");

  // others
  const tabProps = { editItem, setEditItem, form, setData, iframe, setIframe, data, type };

  // effects
  useEffect(() => {
    if (show && editItem && !form.getFieldValue("component")) {
      const values = { ...editItem };
      const formatTime = (t) => (t ? dayjs(t, "YYYY-MM-DD HH:mm") : null);

      values.timeRange = Array.isArray(editItem.timeRange) ? editItem.timeRange?.map(formatTime) : [];
      values.barTimeRange = Array.isArray(editItem.barTimeRange) ? editItem.barTimeRange?.map(formatTime) : [];
      values.lineTimeRange = Array.isArray(editItem.lineTimeRange) ? editItem.lineTimeRange?.map(formatTime) : [];

      form.setFieldsValue(values);
    }
  }, [editItem, show, form]);

  useEffect(() => {
    const component = componentsOptions.find((component) => component?.value === editItem?.component) || {};
    setSelectedComponent(component);
    const tabs = getModalTabs(component);
    if (Array.isArray(tabs) && tabs.length > 0) {
      if (component?.value === "splitCounter" && editItem?.counterDataType === "custom") {
        setTabItems(tabs?.filter((tab) => tab.key !== "timeFrame"));
      } else {
        setTabItems(tabs);
      }
      setSelectedTab((pre) => pre || tabs[0].key);
    }
  }, [editItem?.component, editItem?.counterDataType]);

  // handler
  const handleClose = () => {
    setShow(false);
    setEditItem({});
  };

  const backHandler = () => {
    setShow(false);
    setComponentModal(true);
  };

  // have to change according new data
  // const handleCreate = (data) => {
  //   setGridData((prev) => [...prev, data]);
  //   setShow(false);
  // };

  // const handleEdit = (data) => {
  //   const updated = gridData.map((item) => {
  //     if (item._id === data._id) item = { ...item, ...data };
  //     return item;
  //   });
  //   setGridData(updated);
  //   setShow(false);
  // };

  const handleCreate = (data) => {
    setGridData((prev) => [...prev, data]);
    setShow(false);
  };

  const handleEdit = (data) => {
    const updated = gridData.map((item) => {
      if (item._id === data._id) item = { ...item, ...data };
      return item;
    });
    setGridData(updated);
    setShow(false);
  };

  const onFinish = () => {
    const data = { ...editItem };
    if (editItem.component === "iframe") {
      setIframe(editItem.iframe);
      return setShow(false);
    }

    if (mode === "edit") {
      handleEdit(data);
    } else {
      handleCreate(data);
    }
    setEditItem({});
  };

  const ActiveTabComponent = TAB_COMPONENT_MAP[selectedTab];

  return (
    <>
      <Modal show={show} onHide={handleClose} centered size="" dialogClassName="dashboard-modal" enforceFocus={false}>
        {/* header */}
        <Modal.Header closeButton>
          <div className="d-flex align-items-center justify-content-between w-100">
            <div>
              <Button color="default" variant="text" size="small" onClick={backHandler}>
                <MdOutlineKeyboardBackspace className="fs-4" />
              </Button>
            </div>
            <Modal.Title className="fs-6">{`Edit ${selectedComponent.label}`}</Modal.Title>
            <div className="opacity-0"></div>
          </div>
        </Modal.Header>

        {/* preview */}
        <Modal.Body className="p-4 bg-body-tertiary">
          <div className="mb-1">Live Preview</div>
          <div
            // className="bg-white p-3 shadow-sm rounded-3"
            className={`dashboardTiles border-0 p-3 ${editItem.isBorderHidden ? "" : "withBorder"}`}
            style={{ height: selectedComponent?.minHeight || 100 }}
          >
            <DashboardPreview
              {...{
                iframe,
                setIframe,
                item: {
                  ...editItem,
                },
              }}
            />
          </div>
        </Modal.Body>
        {/* body */}
        <Modal.Body className="p-4">
          <Tabs activeKey={selectedTab} items={tabItems} onChange={(key) => setSelectedTab(key)} />

          <Form
            layout="vertical"
            name="dashboard123123123435234"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            form={form}
            scrollToFirstError={true}
            onValuesChange={() => {
              setTimeout(() => {
                const latestValues = form.getFieldsValue(true);
                const modified = { ...editItem, ...latestValues };
                modified.interval = (modified.intervalTime || 1) * (modified.intervalValue || 1);
                modified.barInterval = (modified.barIntervalTime || 1) * (modified.barIntervalValue || 1);
                modified.lineInterval = (modified.lineIntervalTime || 1) * (modified.lineIntervalValue || 1);

                setEditItem(modified);
              }, 100);
            }}
            initialValues={{ chartType: "canvasJs" }}
          >
            {/* body */}
            {editItem.component && ActiveTabComponent ? <ActiveTabComponent {...tabProps} /> : ""}

            {/* footer */}
            <div className="d-flex align-items-center justify-content-end gap-2 pt-2">
              <Button type="primary" htmlType="submit" disabled={editItem.component !== "iframe" && isEditorEmpty(editItem?.chartTitle || "")}>
                {mode === "edit" ? "Update" : "Create"}
              </Button>
              <Button type="primary" className="bg-secondary" onClick={handleClose} htmlType="button">
                Cancel
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default DashboardAddItemModal;

DashboardAddItemModal.propTypes = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  mode: PropTypes.string,
  editItem: PropTypes.object,
  setEditItem: PropTypes.func,
  gridData: PropTypes.array,
  setGridData: PropTypes.func,
  data: PropTypes.object,
  setData: PropTypes.func,
  iframe: PropTypes.string,
  setIframe: PropTypes.func,
  setComponentModal: PropTypes.func,
  type: PropTypes.string,
};
